import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultadoMatriculasFatorPonderacao } from '../../dtos/resultado-matriculas-fator-ponderacao';
import { ResultadoDistribuicaoDespesaPorEtapa } from '../../dtos/resultado-distribuicao-despesa-por-etapa';

export interface LinhaModalidade {
  item: string;
  nota?: number;
  matriculas: number;
  valor: number;
}

// Fonte única das linhas da tabela: usada pela tela e pelos CSVs dos relatórios.
export function montarLinhasAdicionalModalidade(
  m: ResultadoMatriculasFatorPonderacao | undefined,
  d: ResultadoDistribuicaoDespesaPorEtapa | undefined,
): LinhaModalidade[] {
  return [
    { item: 'Escolas em comunidades indígenas', matriculas: m?.totalMatriculaIndigena ?? 0, valor: d?.despesaFatorIndigena ?? 0 },
    { item: 'Escolas em comunidades quilombolas', matriculas: m?.totalMatriculaQuilombola ?? 0, valor: d?.despesaFatorQuilombola ?? 0 },
    { item: 'Educação Profissional Integrada e concomitante ao Ensino Médio', nota: 1, matriculas: m?.totalMatriculaEnsMedioProf ?? 0, valor: d?.despesaFatorEnsMedioProfissional ?? 0 },
    { item: 'Educação Profissional Integrada e concomitante à EJA', nota: 1, matriculas: m?.totalMatriculaEjaProf ?? 0, valor: d?.despesaFatorEjaProfissional ?? 0 },
    { item: 'Atendimento Educacional Especializado (AEE)', nota: 2, matriculas: m?.totalMatriculaAee ?? 0, valor: d?.despesaFatorAee ?? 0 },
  ];
}

@Component({
  selector: 'app-tabela-adicional-modalidade',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tabela-adicional-modalidade.component.html',
  styleUrl: './tabela-adicional-modalidade.component.scss',
})
export class TabelaAdicionalModalidadeComponent {
  @Input() matriculas!: ResultadoMatriculasFatorPonderacao;
  @Input() despesa!: ResultadoDistribuicaoDespesaPorEtapa;
  @Input() estiloProjecao = false;
  @Output() downloadClick = new EventEmitter<void>();

  get linhas(): LinhaModalidade[] {
    return montarLinhasAdicionalModalidade(this.matriculas, this.despesa);
  }
}
